var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalWinAmountIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 383.29 382.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "total_win_amount_icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2215,0V22.38h-30.75v4.74c0,35.41.08,70.82,0,106.23-.14,45.4-27,84-69.51,99.88-59.39,22.28-127.55-16-139.18-78.36a130.59,130.59,0,0,1-2.15-23c-.23-34.78-.1-69.57-.1-104.36V22.64h-30.75V0Z",
    transform: "translate(-1887.05)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2270.35,125.75c-1,4.6-1.81,9.25-3.08,13.77a78.49,78.49,0,0,1-72.73,56.84c-1.1,0-2.2,0-3.74,0,2.31-5.12,5-9.68,6.44-14.6,1.78-6.08,5.07-8.78,11.34-10.58,23.14-6.65,39.09-28.53,39.28-52.61.13-16.09,0-32.18,0-48.27V67.5H2207V44.91h63.38Z",
    transform: "translate(-1887.05)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1973.35,382.94V360.88h32.37c0-8.95,0-17.4,0-25.85,0-9.27,3.78-16.59,12.16-20.72a32.34,32.34,0,0,1,11.49-2.67c5.3-.44,10.66-.11,16.33-.11V258.8c11.25,1.08,22.22,2.95,33.19,3s21.7-1.89,32.72-3v52.74c1.52,0,2.82,0,4.12,0,5.72.14,11.51-.19,17.17.55a21.22,21.22,0,0,1,18.56,20c.49,7.95.21,15.95.27,23.94,0,1.46,0,2.93,0,4.75H2184v22.21Z",
    transform: "translate(-1887.05)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1966.38,196.27a69,69,0,0,1-24.59-3.53,78.56,78.56,0,0,1-54.65-74c-.16-23.57,0-47.14,0-70.71V45.17h63.44V67.24h-41V71c0,15.59,0,31.18,0,46.77a56.48,56.48,0,0,0,44.6,55.1,5.26,5.26,0,0,1,3.35,2.2c3.09,6.52,5.91,13.16,8.79,19.77A4.77,4.77,0,0,1,1966.38,196.27Z",
    transform: "translate(-1887.05)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalWinAmountIcon);
export default __webpack_public_path__ + "static/media/total_win_amount_icon.703355cbc4c44cd92eeca0b4f8e56f62.svg";
export { ForwardRef as ReactComponent };